import Reveal from "@/components/Reveal";

export default function SectionHeading({ eyebrow, title, desc, center = false, light = false, index }) {
  return (
    <div className={`${center ? "text-center mx-auto max-w-2xl" : "max-w-2xl"} relative`}>
      {index && (
        <Reveal>
          <div className={`section-index text-[64px] sm:text-[88px] mb-2 ${light ? "!text-transparent [-webkit-text-stroke:1.2px_rgba(255,255,255,0.18)]" : ""}`}>
            {index}
          </div>
        </Reveal>
      )}
      {eyebrow && (
        <Reveal>
          <div className={`eyebrow ${center ? "center" : ""} mb-4`}>{eyebrow}</div>
        </Reveal>
      )}
      <Reveal delay={60}>
        <h2 className={`font-display text-[2rem] sm:text-[2.7rem] font-bold leading-[1.05] ${light ? "text-white" : "text-ink"}`}>
          {title}
        </h2>
      </Reveal>
      {desc && (
        <Reveal delay={120}>
          <p className={`mt-5 text-[15.5px] leading-relaxed ${light ? "text-white/65" : "text-slate-600"}`}>
            {desc}
          </p>
        </Reveal>
      )}
    </div>
  );
}
